       import React from 'react'
import { useSelector } from 'react-redux'
import Empty from '../../../../../components/SpaceContent/Empty';
       
export default function PlaylistHeader() {
    const { currentPlaylist, selected } = useSelector(
        state => ({
            selected: state.playlists.selected.length,
            currentPlaylist: state.playlists.allPlaylists.find(cur => cur.id === state.playlists.selected[0])
        }))
    
    return (
        <>     
            {selected === 1 && currentPlaylist &&
            <div>
                <span>ТРЕКИ ПЛЕЙЛИСТА</span>
                <h3>{`"${currentPlaylist.name}"`}</h3>
            </div>}
             {selected === 0 && <Empty>Выберите плейлист</Empty>}
        </>
)}
       